import React, {useEffect, useState} from 'react'
import APITable from './ApiTable'
import { ApiLogsData,fetchAPIlogs } from '../helper';
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import SkeletonCard from '../../Auth/Components/SkeletonCard'


type SortConfig = {key: string; direction: 'asc' | 'desc' | null}
interface APILogProps {
  apiKey: string;
  apiName: string;
  startDate: string;
  endDate: string;
  userName: string;
  handleBackButtonClick();
}

const APIDetailsScreen:React.FC<APILogProps>=({
  apiKey,
  apiName,
  startDate,
  endDate,
  userName,
  handleBackButtonClick
}) => {
    const navigator = useNavigate()
    // const location = useLocation();
    // const { apiKey, apiName, startDate, endDate, userName } = location.state as LocationState || {};
  const [columns, setColumns] = useState<string[]>([])
  const [data, setData] = useState<Record<string, any>[]>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [currentPageData, setCurrentPageData] = useState<Record<string, any>[]>([])
  const [totalPages, setTotalPages] = useState<number>(1)
  const [sortConfig, setSortConfig] = useState<SortConfig>({key: '', direction: null})
  const itemsPerPage = 10

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await fetchAPIlogs(apiKey,apiName,startDate,endDate);
        setColumns(ApiLogsData.columns);
        setData(mapDataToColumns(data, ApiLogsData.columns));
        setTotalPages(Math.ceil(data.length / itemsPerPage));
        
      } catch (error) {
        console.error('Error for API details data:', error);
      } finally {
        setLoading(false); 
      }
    };
  
    fetchData();
  }, [apiKey,apiName,startDate,endDate]);

  const mapDataToColumns = (
    data: Record<string, any>[],
    columns: string[]
  ): Record<string, any>[] => {
    if (!data || !Array.isArray(data)) {
      console.warn('mapDataToColumns received invalid data:', data)
      return []
    }

    return data.map((row) => {
      const mappedRow: Record<string, any> = {}
      columns.forEach((col) => {
        const key = col.replace(/\s+/g, '') // Clean up spaces if needed
        mappedRow[col] = row[key] || '' // Ensure proper key access
      })
      return mappedRow
    })
  }

  const sortData = (data: Record<string, any>[], column: string) => {
    const sortableData = [...data]
    sortableData.sort((a, b) => {
      const aValue = a[column]
      const bValue = b[column]

      const aDate = Date.parse(aValue)
      const bDate = Date.parse(bValue)
      if (!isNaN(aDate) && !isNaN(bDate)) {
        return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate
      }

      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortConfig.direction === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue)
      }

      return 0
    })

    return sortableData
  }

  const handleSort = (column: string) => {
    setSortConfig((prevConfig) => {
      const direction = prevConfig.key === column && prevConfig.direction === 'asc' ? 'desc' : 'asc'
      return {key: column, direction}
    })

    const sortedData = sortData(data, column)
    setData(sortedData)
  }

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }


  useEffect(() => {
    const filteredData = data.filter((row) => {
      const matchesSearch = Object.values(row)
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase())

      return matchesSearch
    })

    setTotalPages(Math.ceil(filteredData.length / itemsPerPage))

    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    const currentPageData = filteredData.slice(startIndex, endIndex)

    setCurrentPageData(currentPageData)
  }, [data, currentPage, searchTerm])

  return (
    <div className='card card-flush mb-6 mb-xl-9 mt-5'>
        <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
     
      <div style={{ flex: 1, textAlign: 'left' }}>
       <button
        type='button'
        className='btn btn-sm'
       style={
         { color: 'white',
          backgroundColor:"#6D9300",
          margin: '10px',
          paddingLeft:'10px'
          }}
       onClick={handleBackButtonClick}
       > <i className='ki-solid ki-double-left text-light fs-2' style={{ paddingRight:"10px"}}></i>
         Back
       </button>
       <span>
       API Usage by 
        <strong> {userName}</strong> for
        <strong style={{ color: 'green' }}> {apiName}</strong>
        </span>
      </div>
    </div>
  
      {loading ? (
        <SkeletonCard />
      ) : (
        <>
          <APITable
            columns={columns}
            handleNextClick={handleNextClick}
            handlePriviousClick={handlePreviousClick}
            data={currentPageData}
            searchTerm={searchTerm}
            handleSort={handleSort}
            sortConfig={sortConfig}
            onSearch={(term) => {
              setSearchTerm(term)
              setCurrentPage(1) 
            }}
          />

          <ul className='pagination justify-content-center' style={{margin: '15px 0'}}>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => {
                  if (handlePreviousClick) handlePreviousClick()
                }}
                disabled={currentPage === 1}
                aria-label='Previous'
              >
                &laquo; Previous
              </button>
            </li>

            <li className='page-item active'>
              <div className='d-flex align-items-center'>
                <button
                  className='page-link'
                  style={{backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none'}}
                >
                  {currentPage}
                </button>
                <span className='mx-2'>of</span>
                <button
                  className='page-link'
                  style={{backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none'}}
                >
                  {totalPages}
                </button>
              </div>
            </li>

            <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => {
                  if (handleNextClick) handleNextClick()
                }}
                disabled={currentPage >= totalPages}
                aria-label='Next'
              >
                Next &raquo;
              </button>
            </li>
          </ul>
        </>
      )}
    </div>
  )
}

export default  APIDetailsScreen
